// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  position: relative;
}
footer .text-themecolor {
  color: #232323;
}
footer.pos-fixed {
  left: 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: -10;
}
footer .footer-menu span {
  color: #232323;
}
footer .footer-menu ul,
footer .footer-menu li {
  list-style: none;
}
footer a {
  transition: var(--default-transition);
}
footer a:hover {
  color: var(--base-color, #232323);
}
footer .subtitle {
  color: #232323;
}
footer.dark .text-themecolor {
  color: #fff;
}
footer.dark .footer-menu span {
  color: #f7f7f7;
}
footer.dark a {
  transition: var(--default-transition);
}
footer.dark a:hover {
  color: #ffffff;
}
footer.dark .subtitle {
  color: #828282;
}

.footer-style-03 form input {
  box-shadow: none;
}
@media (max-width: var(--xs)) {
  .footer-style-03 form button {
    width: auto;
    position: absolute !important;
    top: 0;
    right: 0px;
    bottom: 0;
    border: 0;
    padding: 0px 18px;
    letter-spacing: inherit;
    overflow: hidden;
    height: 46px;
    margin-top: 0;
    border-radius: 2px;
  }
}
.footer-style-03 form button.btn-gradient {
  background-image: linear-gradient(to right, #556fff, #ff798e, #556fff) !important;
  color: #fff;
  background-size: 200% auto;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.footer-style-03 form button.btn-gradient:hover {
  background-position: right center;
}

.footer-style-04 .subscribe-style-09 form input {
  box-shadow: none;
}
@media (max-width: var(--xs)) {
  .footer-style-04 .subscribe-style-09 form button {
    width: auto;
    position: absolute !important;
    top: 0;
    right: 0px;
    bottom: 0;
    border: 0;
    padding: 0px 18px;
    letter-spacing: inherit;
    overflow: hidden;
    height: 43px;
    margin-top: 0;
    border-radius: 2px;
  }
}
.footer-style-04 .subscribe-style-09 form button.btn-gradient {
  background-image: linear-gradient(to right, #556fff, #ff798e, #556fff) !important;
  color: #fff;
  background-size: 200% auto;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.footer-style-04 .subscribe-style-09 form button.btn-gradient:hover {
  background-position: right center;
}

@media (max-width: var(--xs)) {
  .footer-style-05 .subscribe-style-09 form button {
    width: auto;
    position: absolute !important;
    top: 0;
    right: 0px;
    bottom: 0;
    border: 0;
    padding: 0px 18px;
    letter-spacing: inherit;
    overflow: hidden;
    height: 44px;
    margin-top: 0;
    border-radius: 2px;
  }
}
.footer-style-05 .subscribe-style-09 form button.btn-gradient {
  background: linear-gradient(to right, #0039e3, #8600d4, #0039e3);
  color: #fff;
  background-size: 200% auto;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.footer-style-05 .subscribe-style-09 form button.btn-gradient:hover {
  background-position: right center;
}

.footer-style-09 .subscribe-style-05 input {
  padding: 13px 70px 13px 15px;
  font-size: 14px;
}
.footer-style-09 .subscribe-style-05 form button {
  border: none;
  height: 100%;
}

.footer-style-11 .social-icon {
  row-gap: 0;
}`, "",{"version":3,"sources":["webpack://./src/Assets/scss/layouts/_footer.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;EACE,cAAA;AADJ;AAIE;EACE,OAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAMI;EACE,cAAA;AAJN;AAOI;;EAEE,gBAAA;AALN;AASE;EACE,qCAAA;AAPJ;AASI;EACE,iCAAA;AAPN;AAWE;EACE,cAAA;AATJ;AAaI;EACE,WAAA;AAXN;AAeM;EACE,cAAA;AAbR;AAiBI;EACE,qCAAA;AAfN;AAiBM;EACE,cAAA;AAfR;AAmBI;EACE,cAAA;AAjBN;;AAyBI;EACE,gBAAA;AAtBN;AA0BM;EADF;IAEI,WAAA;IACA,6BAAA;IACA,MAAA;IACA,UAAA;IACA,SAAA;IACA,SAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;EAvBN;AACF;AAyBM;EACE,iFAAA;EAIA,WAAA;EACA,0BAAA;EACA,qDAAA;AA1BR;AA4BQ;EACE,iCAAA;AA1BV;;AAqCM;EACE,gBAAA;AAlCR;AAsCQ;EADF;IAEI,WAAA;IACA,6BAAA;IACA,MAAA;IACA,UAAA;IACA,SAAA;IACA,SAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;EAnCR;AACF;AAqCQ;EACE,iFAAA;EAIA,WAAA;EACA,0BAAA;EACA,qDAAA;AAtCV;AAwCU;EACE,iCAAA;AAtCZ;;AAmDQ;EADF;IAEI,WAAA;IACA,6BAAA;IACA,MAAA;IACA,UAAA;IACA,SAAA;IACA,SAAA;IACA,iBAAA;IACA,uBAAA;IACA,gBAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;EA/CR;AACF;AAiDQ;EACE,gEAAA;EACA,WAAA;EACA,0BAAA;EACA,qDAAA;AA/CV;AAiDU;EACE,iCAAA;AA/CZ;;AA4DI;EACE,4BAAA;EACA,eAAA;AAzDN;AA6DM;EACE,YAAA;EACA,YAAA;AA3DR;;AAmEE;EACE,UAAA;AAhEJ","sourcesContent":["// Note: Footer Component only supports dark light class (.text-themecolor).\n// Add the color of your choice to text-themecolor and apply it to .text-themecolor in the footer component area.\nfooter {\n  position: relative;\n\n  .text-themecolor {\n    color: #232323;\n  }\n\n  &.pos-fixed {\n    left: 0;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: -10;\n  }\n\n  .footer-menu {\n    span {\n      color: #232323;\n    }\n\n    ul,\n    li {\n      list-style: none;\n    }\n  }\n\n  a {\n    transition: var(--default-transition);\n\n    &:hover {\n      color: var(--base-color, #232323);\n    }\n  }\n\n  .subtitle {\n    color: #232323;\n  }\n\n  &.dark {\n    .text-themecolor {\n      color: #fff;\n    }\n\n    .footer-menu {\n      span {\n        color: #f7f7f7;\n      }\n    }\n\n    a {\n      transition: var(--default-transition);\n\n      &:hover {\n        color: #ffffff;\n      }\n    }\n\n    .subtitle {\n      color: #828282;\n    }\n  }\n}\n\n// Footer style 04\n.footer-style-03 {\n  form {\n    input {\n      box-shadow: none;\n    }\n\n    button {\n      @media (max-width:var(--xs)) {\n        width: auto;\n        position: absolute !important;\n        top: 0;\n        right: 0px;\n        bottom: 0;\n        border: 0;\n        padding: 0px 18px;\n        letter-spacing: inherit;\n        overflow: hidden;\n        height: 46px;\n        margin-top: 0;\n        border-radius: 2px;\n      }\n\n      &.btn-gradient {\n        background-image: linear-gradient(to right,\n            #556fff,\n            #ff798e,\n            #556fff) !important;\n        color: #fff;\n        background-size: 200% auto;\n        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n\n        &:hover {\n          background-position: right center;\n        }\n      }\n    }\n  }\n}\n\n// Footer style 04\n.footer-style-04 {\n  .subscribe-style-09 {\n    form {\n      input {\n        box-shadow: none;\n      }\n\n      button {\n        @media (max-width:var(--xs)) {\n          width: auto;\n          position: absolute !important;\n          top: 0;\n          right: 0px;\n          bottom: 0;\n          border: 0;\n          padding: 0px 18px;\n          letter-spacing: inherit;\n          overflow: hidden;\n          height: 43px;\n          margin-top: 0;\n          border-radius: 2px;\n        }\n\n        &.btn-gradient {\n          background-image: linear-gradient(to right,\n              #556fff,\n              #ff798e,\n              #556fff) !important;\n          color: #fff;\n          background-size: 200% auto;\n          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n\n          &:hover {\n            background-position: right center;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Footer style 05\n.footer-style-05 {\n  .subscribe-style-09 {\n    form {\n      button {\n        @media (max-width:var(--xs)) {\n          width: auto;\n          position: absolute !important;\n          top: 0;\n          right: 0px;\n          bottom: 0;\n          border: 0;\n          padding: 0px 18px;\n          letter-spacing: inherit;\n          overflow: hidden;\n          height: 44px;\n          margin-top: 0;\n          border-radius: 2px;\n        }\n\n        &.btn-gradient {\n          background: linear-gradient(to right, #0039e3, #8600d4, #0039e3);\n          color: #fff;\n          background-size: 200% auto;\n          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n\n          &:hover {\n            background-position: right center;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Footer style 09\n.footer-style-09 {\n\n  //subscribe form\n  .subscribe-style-05 {\n    input {\n      padding: 13px 70px 13px 15px;\n      font-size: 14px;\n    }\n\n    form {\n      button {\n        border: none;\n        height: 100%;\n      }\n    }\n  }\n}\n\n// Footer style 11\n.footer-style-11 {\n  .social-icon {\n    row-gap: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
